module.exports = __webpack_public_path__ + "img/logo.ab02b2e3.png";